import * as React from "react"

export const ExclusiveContainer = ({ children }: ExclusiveContainer.Props) => {
  return (
    <div className="relative hover:cursor-pointer h-[212px] w-full rounded overflow-hidden">
      {children}
    </div>
  )
}

namespace ExclusiveContainer {
  export type Props = {
    children: React.ReactNode
  }
}
